import upperFirst from 'lodash-es/upperFirst';
import {
    FORUM_MORE_DISCUSSIONS_FROM_topic,
    FORUM_RECENT_POSTS,
    FORUM_SIMILAR_DISCUSSIONS,
} from 'mk/autogenerated/translations/PostDetailRight.7333997ea41ceb8ef17eab1a3d3eb14a'
import { MorePosts, MorePostsPlaceholder } from 'mk2/apps/forum/components/MorePosts';
import SearchPanel from 'mk2/apps/forum/components/SearchPanel';
import { Props } from 'mk2/apps/forum/containers/PostDetail/PostDetailPage';
import { forumSearch } from 'mk2/apps/forum/urls';
import { isCounsellingPost } from 'mk2/apps/forum/utils';
import Interpolate from 'mk2/components/Interpolate';
import LoadingPlaceholder from 'mk2/components/LoadingPlaceholder';
import LoadingSwitch from 'mk2/containers/LoadingSwitch/LoadingSwitch';
import { url } from 'mk2/helpers/urls';
import { interpolate } from 'mk2/services/i18n';
import * as React from 'react';
import styles from './PostDetailRight.mscss';

export class PostDetailRight extends React.Component<Props> {

    public render() {
        const { mobile, nextPosts, similarPosts, recentPosts, loadingState } = this.props;

        return mobile ? null : (
            <>
                <SearchPanel onSubmit={this.onSearch} className={styles.PostDetailRight__searchPanel} />
                <LoadingSwitch
                    loadingState={loadingState}
                    onLoad={this.load}
                    onRenderInit={this.renderInit}
                    onRenderSuccess={this.renderSuccess}
                    onRenderFailure={this.renderFailure}
                    onFailureToast={this.failureToast}
                    hasData={
                        (nextPosts && nextPosts.length > 0)
                        || (recentPosts && recentPosts.length > 0)
                        || (similarPosts && similarPosts.length > 0)
                    }
                />
            </>
        );
    }

    private load = () => {/* nothing to do */};

    private renderInit = () => {
        const { post, contest } = this.props;
        const isCounselling = isCounsellingPost(post);
        const isContest = !!contest;
        return (
            <React.Fragment>
                {!isContest && [
                    <MorePostsPlaceholder
                        key="similar"
                        className={styles.PostDetailRight__nextPosts}
                        title={FORUM_SIMILAR_DISCUSSIONS}
                    />,
                    <MorePostsPlaceholder
                        key="next"
                        className={styles.PostDetailRight__nextPosts}
                        title={isCounselling
                            ? FORUM_RECENT_POSTS
                            : <Interpolate
                                className={styles.PostDetailRight__nextPostsTitle}
                                i18nKey={FORUM_MORE_DISCUSSIONS_FROM_topic}
                                topic={<LoadingPlaceholder width={100} style={{marginLeft: 5}}/>}
                            />
                        }
                    />,
                ]}
            </React.Fragment>
        );
    };

    private renderSuccess = () => {
        const {
            match: { params: { topicSlug } }, nextPosts, post, similarPosts, recentPosts, contest,
        } = this.props;

        const isCounselling = isCounsellingPost(post);
        const isContest = !!contest;

        return (
            <React.Fragment>
                {!isContest && [
                    <MorePosts
                        key="similar"
                        className={styles.PostDetailRight__nextPosts}
                        posts={similarPosts}
                        topicSlug={topicSlug}
                        title={FORUM_SIMILAR_DISCUSSIONS}
                    />,
                    <MorePosts
                        key="next"
                        className={styles.PostDetailRight__nextPosts}
                        posts={isCounselling ? recentPosts : nextPosts}
                        topicSlug={topicSlug}
                        showComments={!isCounselling}
                        title={isCounselling
                            ? FORUM_RECENT_POSTS
                            : interpolate(FORUM_MORE_DISCUSSIONS_FROM_topic, {topic: upperFirst(post.topic.name)})
                        }
                    />,
                ]}
            </React.Fragment>
        );
    };

    private renderFailure = () => null; /* nothing to render */

    private failureToast = () => {/* nothing to do */};

    private onSearch = (query: string) => {
        this.props.history.push(url(forumSearch, {}, { q: query }));
    };
}
